import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'
import { resources as brandResources } from '@/config/brands'

export const theme = {
  rankGradient: 'linear-gradient(90deg, #FF6734 0.03%, #FF42CC 100%)',
} as const

export const resources = {
  homeBg: '/images/storyella/home-bg.webp',
  spikeletL: '/images/storyella/ranking/spikelet_l.png',
  spikeletR: '/images/storyella/ranking/spikelet_r.png',
  goldMedal: brandResources.medals.goldMedal,
  silverMedal: brandResources.medals.silverMedal,
  bronze: brandResources.medals.bronze,
  medal: brandResources.medals.medal,
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
